import { render } from "./Facilities.vue?vue&type=template&id=9cf226a8&ts=true&lang=pug"
import script from "./Facilities.vue?vue&type=script&setup=true&lang=ts"
export * from "./Facilities.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__